import React from 'react';
import { OverlayTrigger, Popover, PopoverContent } from 'react-bootstrap';

const DocumentTypeTooltip = ({ title, tips }) => {
  return tips !== '' ? (
    <OverlayTrigger
      placement="right"
      trigger={['hover', 'focus']}
      overlay={
        <Popover style={{ minWidth: '35rem', marginRight: '0.5rem !important' }}>
          <PopoverContent>
            <h6>{title}</h6>
            <p>{tips}</p>
          </PopoverContent>
        </Popover>
      }
    >
      <div className="info" style={{ width: '1rem', marginRight: '0.5rem' }}></div>
    </OverlayTrigger>
  ) : (
    <div style={{ width: '1.5rem' }}></div>
  );
};

export default DocumentTypeTooltip;
